import React from 'react';
import { green6 } from '../../../colors/COLORS';
import TickIcon from '../../../icons/TickIcon';

const TickIconAtom = () => (
  <TickIcon fill={green6} />
);

export default TickIconAtom;
